import React, { useContext, useState } from 'react'

import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DrawerItem } from './DrawerItem'
import {
  NavigatorContext,
  INavigatorContext,
  NavigatorItemContext,
} from './NavigatorContext'

const SHARED_STYLES = 'flex box-border m-0 w-full'
const CONTAINER_STYLES = `${SHARED_STYLES} flex-col`
const FLEX_CONTAINER_STYLES = SHARED_STYLES

export interface IAccordionProps {
  id?: string
  label?: string
  active?: boolean
  handleToggle?: (id: string) => void
  children: JSX.Element | JSX.Element[]
}

/**
 * An item for the primary navigation drawer representing a
 * collapsable section.
 * @param props Configuration for the item.
 */
export const Accordion: React.FC<IAccordionProps> = ({
  active,
  children,
  handleToggle,
  id,
  label,
}) => {
  const navigator = useContext<INavigatorContext>(NavigatorContext)
  const [hovering, setHovering] = useState<boolean>(false)

  const handleMouse = (over: boolean) => () => {
    if (hovering !== over) {
      setHovering(over)
    }
  }
  const handleClick: React.MouseEventHandler = (e) => {
    e.preventDefault()
    if (handleToggle && id) {
      handleToggle(id)
    }
  }

  return (
    <DrawerItem
      appearanceTheme={navigator.theme}
      active={active}
      onMouseOver={handleMouse(true)}
      onMouseOut={handleMouse(false)}
    >
      <NavigatorItemContext.Provider
        value={{ active: active ?? false, hovering, theme: navigator.theme }}
      >
        <div className={CONTAINER_STYLES}>
          <div className={FLEX_CONTAINER_STYLES} onClick={handleClick}>
            <a className="text-actionable" href="#" onClick={handleClick}>
              <span className={FLEX_CONTAINER_STYLES}>{label}</span>
              <FontAwesomeIcon
                className="my-auto mx-3"
                icon={active ? faChevronUp : faChevronDown}
              />
            </a>
          </div>
          {active ? children : null}
        </div>
      </NavigatorItemContext.Provider>
    </DrawerItem>
  )
}
